import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Foundational shared module
import { SharedCommonModule } from './shared-common.module';

// Feature dependencies that cause circularity with SharedCommonModule
import { MediaLibraryModule } from '../features/media-library/media-library.module';

// Components being relocated to resolve dependencies
import { ArticleCreateComponent } from '../components/user-dashboard/blog/create/article-create/article-create.component';
import { ContactCreateComponent } from '../components/user-dashboard/contacts/create/create.component';

@NgModule({
  declarations: [ArticleCreateComponent, ContactCreateComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    NgbModule,
    SharedCommonModule,
    MediaLibraryModule,
  ],
  exports: [ArticleCreateComponent, ContactCreateComponent],
})
export class SharedPopupsModule {}
